import Constants from '@/Constants';
import React from 'react';
import './style.scss';

interface Props {
    title: string;
    message?: string;
    icon?: string;
    className?: string;
    children?: React.ReactNode;
}

const BoardEmptyState: React.FC<Props> = (props: Props) => {
    const { title, message, children, className, icon = Constants.icons.BALLOT } = props;

    return (
        <div className={`empty-state-section ${className ? className : ''}`} >
            <span className="icon-span">
                <i className="material-icons-outlined icon-center icon">{icon}</i>
            </span>
            <span className="section-title">{title}</span>
            { message && <span className="section-message">{message}</span>}
            { children && <div> {children} </div>}
        </div>
    );
};

export default BoardEmptyState;
